import { createAction, createActionGroup, emptyProps, props } from "@ngrx/store";
import { C3HardwareItem, C3Order, C3OrderedProduct, C3Product, C3ProductBillOfMaterialsLineItem, C3ProductType, C3ProductVersion, C3VendorHardwareData, InventoryTransaction, Resource, SaveStatus, Tag } from "@prism/prism-shared";

export const SetHardwareItem = createActionGroup({
    source: 'C3 SetHardwareItem',
    events: {
        'Initial': props<{ hardwareItem: C3HardwareItem }>(),
        'Success': props<{ hardwareItem: C3HardwareItem }>(),
        'Failure': props<{ error: any }>()
    }
})

export const LoadHardwareItems = createActionGroup({
    source: 'C3 LoadHardwareItems',
    events: {
        'Initial': emptyProps(),
        'Success': props<{ hardwareItems: C3HardwareItem[] }>(),
        'Failure': props<{ error: any }>(),
    }
})

export const LoadHardwareItemById = createActionGroup({
    source: 'C3 LoadHardwareItemById',
    events: {
        'Initial': props<{ hardwareItemId: string }>(),
        'Success': props<{ hardwareItem: C3HardwareItem }>(),
        'Failure': props<{ error: any }>(),
    }
})

export const LoadHardwareItemsByIds = createActionGroup({
    source: 'C3 LoadHardwareItemsByIds',
    events: {
        'Initial': props<{ hardwareItemIds: string[]; }>(),
        'Success': props<{ hardwareItems: C3HardwareItem[]; }>(),
        'Failure': props<{ error: any }>(),
    }
});

export const LoadRecentHardwareInventoryTransactions = createActionGroup({
    source: 'C3 LoadRecentHardwareInventoryTransactions',
    events: {
        'Initial': emptyProps(),
        'Success': props<{ transactions: InventoryTransaction[] }>(),
        'Failure': props<{ error: any }>(),
    }
})

export const LoadVendorHardwareData = createActionGroup({
    source: 'C3 LoadVendorHardwareData',
    events: {
        'Initial': emptyProps(),
        'Success': props<{ vendorHardwareData: C3VendorHardwareData[] }>(),
        'Failure': props<{ error: any }>(),
    }
})

export const LoadVendorHardwareDataByHardwareItemId = createActionGroup({
    source: 'C3 LoadVendorHardwareDataByHardwareItemId',
    events: {
        'Initial': props<{ hardwareItemId: string; }>(),
        'Success': props<{ vendorHardwareData: C3VendorHardwareData[]; }>(),
        'Failure': props<{ error: any }>(),
    }
});

export const LoadVendorHardwareDataByHardwareItemIds = createActionGroup({
    source: 'C3 LoadVendorHardwareDataByHardwareItemIds',
    events: {
        'Initial': props<{ hardwareItemIds: string[] }>(),
        'Success': props<{ vendorHardwareData: C3VendorHardwareData[] }>(),
        'Failure': props<{ error: any }>(),
    }
});

export const SetHardwareInventoryTransaction = createActionGroup({
    source: "C3 SetHardwareInventoryTransaction",
    events: {
        'Initial': props<{ hardwareId: string, qtyChange: number, comment: string}>(),
        'Success': props<{ transaction: InventoryTransaction }>(),
        'Failure': props<{ error: any }>(),
    }
})

export const SetVendorHardwareData = createActionGroup({
    source: 'C3 SetVendorHardwareData',
    events: {
        'Initial': props<{ vendorHardwareData: C3VendorHardwareData }>(),
        'Success': props<{ vendorHardwareData: C3VendorHardwareData }>(),
        'Failure': props<{ error: any }>(),
    }
})

export const SetVendorHardwareDataAndHardwareItem = createActionGroup({
    source: 'C3 SetVendorHardwareDataAndHardwareItem',
    events: {
        'Initial': props<{ hardwareItem: C3HardwareItem; vendorHardwareData: C3VendorHardwareData }>(),
        'Success': props<{ hardwareItem: C3HardwareItem; vendorHardwareData: C3VendorHardwareData }>(),
        'Failure': props<{ error: any }>(),
    }
})

export const LoadProducts = createActionGroup({
    source: 'C3 LoadProducts',
    events: {
        'Initial': emptyProps(),
        'Success': props<{ products: C3Product[]; }>(),
        'Failure': props<{ error: any }>(),
    }
});

export const LoadReleasedAndDraftProductVersions = createActionGroup({
    source: 'C3 LoadReleasedAndDraftProductVersions',
    events: {
        'Initial': emptyProps(),
        'Success': props<{ releasedAndDraftProductVersions: C3ProductVersion[] }>(),
        'Failure': props<{ error: any }>(),
    }
})

export const LoadRecentProductInventoryTransactions = createActionGroup({
    source: 'C3 LoadRecentProductInventoryTransactions',
    events: {
        'Initial': emptyProps(),
        'Success': props<{ transactions: InventoryTransaction[]; }>(),
        'Failure': props<{ error: any }>(),
    }
});

export const SetProduct = createActionGroup({
    source: 'C3 SetProduct',
    events: {
        'Initial': props<{ product: C3Product }>(),
        'Success': props<{ product: C3Product }>(),
        'Failure': props<{ error: any }>(),
    }
})

export const SetProductVersion = createActionGroup({
    source: 'C3 SetProductVersion',
    events: {
        'Initial': props<{ productVersion: C3ProductVersion }>(),
        'Success': props<{ productVersion: C3ProductVersion }>(),
        'Failure': props<{ error: any }>(),
    }
})

export const LoadReleasedProductVersions = createActionGroup({
    source: 'C3 LoadReleasedProductVersions',
    events: {
        'Initial': emptyProps(),
        'Success': props<{ productVersions: C3ProductVersion[] }>(),
        'Failure': props<{ error: any }>(),
    }
})

export const ViewProductLoadProductData = createActionGroup({
    source: 'C3 ViewProductLoadProductData',
    events: {
        'Initial': props<{
            productId: string;
            productVersionId: string;
        }>(),
        'Success': props<{
            selectedProduct: C3Product;
            selectedProductVersionId: string;
            selectedProductVersions: C3ProductVersion[];
            lineItems: C3ProductBillOfMaterialsLineItem[];
            releasedProductVersions: C3ProductVersion[];
            products: C3Product[];
            hardwareItems: C3HardwareItem[];
            selectedDrawingResource: Resource;
            productVersionsReferencingSelectedProduct: C3ProductVersion[];
        }>(),
        'Failure': props<{ error: any }>(),
    }
});

export const SetBillOfMaterialsLineItems = createActionGroup({
    source: 'C3 SetBillOfMaterialsLineItems',
    events: {
        'Initial': props<{ lineItems: C3ProductBillOfMaterialsLineItem[]; }>(),
        'Success': props<{ lineItems: C3ProductBillOfMaterialsLineItem[]; }>(),
        'Failure': props<{ error: any }>(),
    }
});

export const EditProductLoadProductData = createActionGroup({
    source: 'C3 EditProductLoadProductData',
    events: {
        'Initial': props<{ productVersionId: string; }>(),
        'Success': props<{
            product: C3Product;
            productVersion: C3ProductVersion;
            products: C3Product[];
            releasedProductVersions: C3ProductVersion[];
            lineItems: C3ProductBillOfMaterialsLineItem[];
            hardwareItems: C3HardwareItem[];
        }>(),
        'Failure': props<{ error: any }>(),
    }
});

export const EditProductSaveProductVersion = createActionGroup({
    source: 'C3 EditProductSaveProductVersion',
    events: {
        'Initial': emptyProps(),
        'Success': props<{ productVersion: C3ProductVersion; }>(),
        'Failure': props<{ error: any }>(),
    }
});

export const EditProductDeleteDraftProductVersion = createActionGroup({
    source: 'C3 EditProductDeleteDraftProductVersion',
    events: {
        'Initial': props<{ productVersionId: string; }>(),
        'Success': props<{ productVersionId: string; }>(),
        'Failure': props<{ error: any }>(),
    }
});

export const EditProduct = createActionGroup({
    source: 'C3 EditProduct',
    events: {
        'AddLineItem': props<{ lineItem: C3ProductBillOfMaterialsLineItem }>(),
        'AddLineItems': props<{ lineItems: C3ProductBillOfMaterialsLineItem[]; }>(),
        'RemoveLineItem': props<{ lineItemId: string }>(),
        'UpdateLineItem': props<{ lineItem: C3ProductBillOfMaterialsLineItem }>(),
        'AddDrawingResource': props<{ resourceId: string; }>(),
        'RemoveDrawingResource': emptyProps(),
        'UpdatePartNumber': props< { partNumber: string }>(),
        'UpdateCustomerPartNumber': props<{ customerPartNumber: string; }>(),
        'UpdateCustomerId': props<{ customerId: string; }>(),
        'UpdateDescription': props<{ description: string; }>(),
        'UpdateProductType': props<{ productType: C3ProductType; }>(),
        'UpdateImageUrl': props<{ imageUrl: string; }>(),
        'UpdateThumbnailImageUrl': props<{ thumbnailImageUrl: string; }>(),
    }
})

export const SetEditProductSaveStatus = createAction(
    'Metals SetEditProductSaveStatus',
    props<{ saveStatus: SaveStatus }>()
)

export const EditProductReleaseProductVersion = createActionGroup({
    source: 'C3 EditProductReleaseProductVersion',
    events: {
        'Initial': props<{ releaseComment: string; productVersion: C3ProductVersion; }>(),
        'Success': props<{ productVersion: C3ProductVersion; }>(),
        'Failure': props<{ error: any }>(),
    }
});

export const ViewProductClearState = createAction(
    'C3 ViewProductClearState',
)

export const ViewProductUpdate = createActionGroup({
    source: 'C3 ViewProductUpdate',
    events: {
        'UpdateSelectedProductVersion': props<{ productVersion: C3ProductVersion }>(),
        'UpdateSelectedProduct': props<{ product: C3Product }>(),
        'SetSelectedProductVersionId': props<{ productVersionId: string }>(),
    }
})

export const LoadBillOfMaterialsLineItemsByProductVersionId = createActionGroup({
    source: 'C3 LoadBillOfMaterialsLineItemsByProductVersionId',
    events: {
        'Initial': props<{ productVersionId: string }>(),
        'Success': props<{ lineItems: C3ProductBillOfMaterialsLineItem[] }>(),
        'Failure': props<{ error: any }>(),
    }
})

export const ViewProductLoadSelectedProduct = createActionGroup({
    source: 'C3 ViewProductLoadSelectedProduct',
    events: {
        'Initial': props<{ productId: string; }>(),
        'Success': props<{ product: C3Product }>(),
        'Failure': props<{ error: any; }>(),
    }
})

export const LoadProductsByIds = createActionGroup({
    source: 'C3 LoadProductsByIds',
    events: {
        'Initial': props<{ productIds: string[]; }>(),
        'Success': props<{ products: C3Product[]; }>(),
        'Failure': props<{ error: any }>(),
    }
});

export const SetProductInventoryTransaction = createActionGroup({
    source: 'C3 SetProductInventoryTransaction',
    events: {
        'Initial': props<{
            productId: string,
            qtyChange: number;
            comment: string;
            hardwareIdToQuantityChangeDict: Record<string, number>;
            productIdToQuantityChangeDict: Record<string, number>;
        }>(),
        'Success': props<{
            transaction: InventoryTransaction;
            hardwareIdToQuantityChangeDict: Record<string, number>;
            productIdToQuantityChangeDict: Record<string, number>;
        }>(),
        'Failure': props<{ error: any }>(),
    }
});

export const SetComponentGroupBomInventoryTransaction = createActionGroup({
    source: 'C3 SetComponentGroupBomInventoryTransaction',
    events: {
        'Initial': props<{
            comment: string;
            hardwareIdToQuantityChangeDict: Record<string, number>;
            productIdToQuantityChangeDict: Record<string, number>;
        }>(),
        'Success': props<{
            transactions: InventoryTransaction[];
            hardwareIdToQuantityChangeDict: Record<string, number>;
            productIdToQuantityChangeDict: Record<string, number>;
        }>(),
        'Failure': props<{ error: any }>(),
    },
});

export const LoadOrders = createActionGroup({
    source: 'C3 LoadOrders',
    events: {
        'Initial': emptyProps(),
        'Success': props<{ orders: C3Order[] }>(),
        'Failure': props<{ error: any }>(),
    }
})

export const LoadOrderedProducts = createActionGroup({
    source: 'C3 LoadOrderedProducts',
    events: {
        'Initial': emptyProps(),
        'Success': props<{ orderedProducts: C3OrderedProduct[] }>(),
        'Failure': props<{ error: any }>(),
    }
})
